import { useEffect, useState } from "react";
import fetchNFTNames, { Name } from "src/apis/fetchNFTNames";
import { Table } from "react-bootstrap";
import { twitter } from "src/assets/images";

interface IProps {
  contractAddress: string;
  tokenId: string | number;
  providedName: string;
  namingTweet: any;
}

const initialState: Name[] = [];

function NameHistory({
  contractAddress,
  tokenId,
  providedName,
  namingTweet,
}: IProps) {
  //@ts-ignore
  const [namesHistory, setNamesHistory] = useState<Name[]>(initialState);

  function mergeNamingHistoryWithNamingTweets(arr1: any, arr2: any) {
    const merged = [
      ...arr1
        .concat(arr2)
        .reduce(
          (m: any, o: any) =>
            m.set(o?.name, Object.assign(m.get(o?.name) || {}, o)),
          new Map()
        )
        .values(),
    ];

    return merged;
  }

  useEffect(() => {
    if (namesHistory.length) {
      setTimeout(() => {
        fetchNFTNames(contractAddress, tokenId)
          .then((res) => {
            setNamesHistory(res.sort((a, b) => b.timestamp - a.timestamp));
          })
          .catch(console.error);
      }, 3000);
    } else {
      fetchNFTNames(contractAddress, tokenId)
        .then((res) => {
          setNamesHistory(res.sort((a, b) => b.timestamp - a.timestamp));
        })
        .catch(console.error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractAddress, tokenId, providedName]);

  let mergedHistory;

  if (namesHistory && namingTweet) {
    mergedHistory = mergeNamingHistoryWithNamingTweets(
      namesHistory,
      namingTweet
    );
  }

  return (
    <>
      {mergedHistory && mergedHistory.length ? (
        <Table className="namehistory-table">
          <thead className="namehistory-thead">
            <tr className="namehistory-header-tr">
              <th className="namehistory-th" colSpan={2}>
                NAMING HISTORY
              </th>
            </tr>
          </thead>
          <tbody className="namehistory-tbody">
            {mergedHistory.map((e) => (
              <tr key={e.transactionHash} className="namehistory-body-tr">
                <td className="namehistory-timestamp-td">
                  {formatDT(e.timestamp)}
                </td>
                <td className="namehistory-name-td">
                  <a
                    href={`https://etherscan.io/tx/${e.transactionHash}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: "inherit",
                      color: "#fc4ba3",
                    }}
                  >
                    {e.name}
                  </a>
                </td>
                <td>
                  {e.tweetUrl && (
                    <a
                      className="text-white"
                      href={e.tweetUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={twitter}
                        alt="Twitter Logo"
                        style={{ width: "20px" }}
                      />
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : null}
    </>
  );
}

const formatDT = (timestamp: number) => {
  let date = new Date(timestamp);
  let hours: number | string = date.getHours();
  let minutes: number | string = date.getMinutes();
  if (hours.toString().length === 1) {
    hours = `0${hours.toString()}`;
  }
  if (minutes.toString().length === 1) {
    minutes = `0${minutes.toString()}`;
  }
  return `${("0" + date.getDate()).slice(-2)}/${(
    "0" +
    (date.getMonth() + 1)
  ).slice(-2)}/${date.getFullYear()}`;
};

export default NameHistory;
